import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { Alert, Avatar, Card, Image, Spin, Tag, Tooltip } from "antd";
import { GlobalOutlined, HomeOutlined, PhoneOutlined, TagOutlined, UserOutlined } from "@ant-design/icons";
import CardImageItem from "./CardImage";
import {formatDate} from '../../../Components/Common/FormatDate/FormatDate'


const DetailUser = ({ modal, setModal, toggle, selectedUser }) => {

    const { name, email, phone, address, cniNumber, licenseNumber, createdAt, updatedAt, status, role, vehicle, fileName } = selectedUser || {};
    const roleName = role?.name || "-";

  return (
    <Modal isOpen={modal} toggle={toggle} centered backdrop="static" style={{ maxWidth: "900px" }}>
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        <span>Détail de l'utilisateur {name} </span>
      </ModalHeader>

      <ModalBody>
        <div className="text-center mb-4">
          <Avatar size={300} style={{ width: "150px", height: "150px", overflow: "hidden" }}>
            <CardImageItem fileName = {fileName} />
          </Avatar>
        </div>

        <div className="text-center mb-4">
          <h4>{name || "-"} </h4>
          <h6 className="text-mutued">{roleName === "DRIVER" ? "Chauffeur" : roleName ||"-"} </h6>
          <p>
            <Tooltip title="Statut de l'utilisateur">
              <Tag color={status === 'Actif' ? 'green' : 'volcano'} icon={<TagOutlined />}>
                {status === 'Actif' ? 'Actif' : 'Inactif'}
              </Tag>
            </Tooltip>
          </p>
        </div>
        <Card className="card-animate" title="Détails de Compte" style={{ marginBottom: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
          <Row >
            <Col lg={3}>
              <div>
                <strong>Email : </strong> <span>{ email || '-' }</span>
              </div>
            </Col>
            <Col lg={3}>
              <div>
                <strong>Téléphone : </strong> <span>{ phone || '-' }</span>
              </div>
            </Col>
            <Col lg={3}>
              <div>
                <strong>Adress : </strong> <span>{ address || '-' }</span>
              </div>
            </Col>
            <Col lg={3}>
              <div>
                <strong>Créé le : </strong> <span>{formatDate(createdAt) || '-' }</span>
              </div>
            </Col>
          </Row>
        </Card>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => setModal(false)}>Fermer</Button>
      </ModalFooter>
    </Modal>
  );

};

export default DetailUser;
